/**
 * Chart ids a report section may carry.
 *
 * The server decides WHICH exhibits belong in a section — that is a
 * reporting standard, not a display preference — and the client draws
 * them from the calculation log and evidence rows. No chart invents a
 * number; each one plots figures the engine already produced.
 */
export const REPORT_CHARTS = [
    'valuation_bridge',
    'nav_composition',
    'latent_tax_position',
    'latent_tax_sensitivity',
    'discount_evidence',
    'discount_sensitivity',
    'earnings_weighting',
    'comparable_multiples',
    'transaction_timeline',
    'provenance_summary',
];
export const CHART_CAPTIONS = {
    valuation_bridge: 'From the assets valued to the market value of the interest',
    nav_composition: 'Composition of gross assets',
    latent_tax_position: 'Latent tax: full charge, the deduction adopted, and the corridor',
    latent_tax_sensitivity: 'Sensitivity of the holding value to the latent-tax deduction adopted',
    discount_evidence: 'Discounts adopted against the published evidence ranges',
    discount_sensitivity: 'Holding value across the discount ranges',
    earnings_weighting: 'Normalised earnings by period and the weighting applied',
    comparable_multiples: 'The comparable set and the multiple adopted',
    transaction_timeline: 'Transactions in the subject shares relative to the valuation date',
    provenance_summary: 'Evidential basis of the facts relied upon',
};
//# sourceMappingURL=types.js.map